import React from 'react';
import { useNavigate } from 'react-router-dom';

function HeroBanner() {
  const navigate = useNavigate();

  const handleLeftSideClick = () => {
    navigate('/products');
  };

  return (
    <section className="w-full relative">
      <img
        src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/cd831b255db46077663cb56df2242ba7d58c97ef?placeholderIfAbsent=true"
        alt="Hero banner showcasing clothing collection"
        className="object-cover w-full h-[488px] max-md:h-[300px]"
      />

      {/* Clickable left region overlay */}
      <div
        onClick={handleLeftSideClick}
        className="absolute top-0 left-0 w-1/2 h-full cursor-pointer hover:bg-black hover:bg-opacity-10 transition-all duration-300 z-10"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleLeftSideClick();
          }
        }}
        aria-label="Navigate to products page"
        title="Click to view products"
      />
    </section>
  );
}

export default HeroBanner;
